// extracted by mini-css-extract-plugin
export var content = "_sg-1";
export var wrapper = "_sg-0";